import db from "./db";

export async function addReceipt(object) {
  const newReceipt = {
    ...object,
  };

  try {
    await db.receipts.add(newReceipt);
    return true;
  } catch (error) {
    console.error("Error saving receipt:", error);
    return false;
  }
}
